import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { Routes } from '@/router';
import { LoyaltyExplainerModalState } from '@/components/modals/CmgLoyaltyExplainerModal/cmg-loyalty-explainer-modal';
import { AnalyticsEventCategory, AnalyticsEventAction, AnalyticsEventLabel } from '@/services/google/google-analytics.services';

@Component({
  name: 'CmgLoyaltyQuestions',
})
export default class CmgLoyaltyQuestions extends Vue {
  onClickExplainRewards(event: any) {
    this.$services.googleAnalytics.sendCustomEvent({
      category: AnalyticsEventCategory.RewardsLanding,
      action: AnalyticsEventAction.HowRewardsWorkCtaClick,
      label: AnalyticsEventLabel.RewardsLandHowRewardsWorkClick,
    });
    this.$services.ui.pushEventTargetAsLastSelectedElement(event);
    this.$services.ui.setModalVisibility('loyaltyExplainer', true, { state: LoyaltyExplainerModalState.Explainer });
    this.$services.ui.firstFocus();
  }

  onClickRequestPoints() {
    this.$services.googleAnalytics.sendCustomEvent({
      category: AnalyticsEventCategory.RewardsLanding,
      action: AnalyticsEventAction.PointRequestClick,
      label: AnalyticsEventLabel.RewardsLandPointRequestClick,
    });
    this.$services.ui.nextFocus('retro-credit-landing');
    this.$router.push({ name: Routes.RetroCredit });
  }

  onClickFullTerms() {
    this.$services.googleAnalytics.sendCustomEvent({
      category: AnalyticsEventCategory.RewardsLanding,
      action: AnalyticsEventAction.RewardsTermsClick,
      label: AnalyticsEventLabel.RewardsLandTermsClick,
    });
    window.open('https://www.chipotle.com/about-us/rewards-terms', '_blank');
  }

  onClickFAQ() {
    this.$services.googleAnalytics.sendCustomEvent({
      category: AnalyticsEventCategory.RewardsLanding,
      action: AnalyticsEventAction.RewardsFaqClick,
      label: AnalyticsEventLabel.RewardsLandFaqClick,
    });
    window.open(this.$services.config.getFaqUrl(), '_blank');
  }
}
